var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "edit-table" }, [
    _c(
      "div",
      { staticClass: "form-item" },
      [
        _c("label", [_vm._v(_vm._s(_vm.$t("tables.tableName")))]),
        _vm._v(" "),
        _c("a-input", {
          model: {
            value: _vm.form.name,
            callback: function ($$v) {
              _vm.$set(_vm.form, "name", $$v)
            },
            expression: "form.name",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-item" },
      [
        _c("label", [_vm._v(_vm._s(_vm.$t("tables.description")))]),
        _vm._v(" "),
        _c("a-textarea", {
          model: {
            value: _vm.form.description,
            callback: function ($$v) {
              _vm.$set(_vm.form, "description", $$v)
            },
            expression: "form.description",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-item" },
      [
        _c(
          "a-button",
          { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
          [_vm._v(_vm._s(_vm.$t("message.save")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }